import {Dialog, Layout, Spacer, Text} from '@di-nxt/components';
import React from 'react';
import {t} from '../../../localization';
import {ModalProps} from '../../../services';
import {
  AbsenceTypeEditor,
  CommentEditor,
  MemberEditor,
  PeriodEditor,
} from './editors';
import {useAbsenceModalState} from './hooks';
import {AddAbsenceProps} from './types';

export const AbsenceModal: React.FC<ModalProps<AddAbsenceProps, boolean>> = ({
  teamId,
  absence,
  absenceType,
  callback,
}) => {
  const {
    handleFromDateChanged,
    handleToDateChanged,
    handleAbsenceTypeChanged,
    handleMemberIdChanged,
    handleCommentChanged,
    isValid,
    numberOfDays,
    submit,
    cancel,
  } = useAbsenceModalState(teamId, absence, absenceType, callback);

  return (
    <Dialog
      size="Small"
      okButtonTitle={absence ? t('general.save') : t('general.add')}
      cancelButtonTitle={t('general.cancel')}
      title={
        absence
          ? t('screens.schedule.absencedialog.titles.edit')
          : t('screens.schedule.absencedialog.titles.add')
      }
      hasCloseButton
      okButtonDisabled={!isValid}
      onCancelButton={cancel}
      onOkButton={submit}>
      <Layout vertical flex>
        {/** Select person */}
        <MemberEditor
          absence={absence}
          teamId={teamId}
          onMemberChanged={handleMemberIdChanged}
        />
        <Spacer height={'20'} />
        {/** Select type of absence */}
        <AbsenceTypeEditor
          absence={absence}
          onAbsenceTypeChanged={handleAbsenceTypeChanged}
        />
        <Spacer height={'20'} />
        {/** Select to / from dates */}
        <PeriodEditor
          fromDate={absence?.fromDate}
          toDate={absence?.toDate}
          onFromDateChanged={handleFromDateChanged}
          onToDateChanged={handleToDateChanged}
        />
        <Spacer height={'20'} />
        {/* Length of period */}
        <Text
          textColor={numberOfDays ? undefined : 'transparent'}
          align="right">
          {numberOfDays ?? ' - '}
        </Text>
        <Spacer height={'20'} />
        {/** Comment */}
        <CommentEditor
          comment={absence?.comment}
          onCommentsUpdated={handleCommentChanged}
        />
      </Layout>
    </Dialog>
  );
};
